module.exports = __webpack_public_path__ + "img/teman-bus-icon.4ce3d581.png";